export const setOrderListPagination = (page, rowsPerPage) => {
  return {
    // Unique identifier
    type: 'SET_ORDERLIST',
	page: page,
	rowsPerPage: rowsPerPage
  }
};

export const setOrderListPage = (page) => {
  return {
    // Unique identifier
    type: 'SET_PAGE',
	page: page
  }
};

export const setOrderListRowsPerPage = (rowsPerPage) => {
  return {
    // Unique identifier
    type: 'SET_ROWSPERPAGE',
	rowsPerPage: rowsPerPage
  }
};

export const setProcessing = (processing) => {
//  console.log("setProcessing: "+processing);
  return {
    // Unique identifier
    type: 'SET_PROCESSING',
	processing: processing
  }
};

export const setMaxorders = (maxorders) => {
//  console.log("setMaxorders: "+maxorders);
  return {
    // Unique identifier
    type: 'SET_MAXORDERS',
	maxorders: maxorders
  }
};
